import { Label, Col } from "client/CommonComponents";
import './AfeDetail.scss'
import { formatPrice } from "utils";
import moment from "moment";
import { CONSTANTS } from "client/utils/constants";

const AfeDetail = (props: any) => {
    const { item, fields, assetOrderHeaderDetail } = props;

  return <div className="p-3 afeorder_content">
    <Col xl={12}>
      <div className='row'>
        <Col xl={12} md={12}>
          <div className="row">
            {fields?.includes('unitNumber') && <Col xl={3} md={4} className={'pt-3'}>
              <div>
                <Label data-attribute="AfeDetail_Default_Label">Unit #</Label>
                <span>{item.unitNumber || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('year') && <Col xl={3} md={4} className={'pt-3'}>
              <div>
                <Label data-attribute="AfeDetail_Default_Label_2">Year</Label>
                <span>{item.year || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('color') && <Col xl={3} md={4} className="pt-3 pt-xl-0 pt-lg-0 pt-md-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_3">Color</Label>
                <span>{item.color || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('equipmentStatus') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_4">Equipment Status</Label>
                <span>{item.eqStatus || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('invoicedAmount') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_5">Quoted Amount</Label>
                <span>$ {formatPrice(item.invoicedAmount, 2) ?? '$ 0.00'}</span>
              </div>
            </Col>}
            {fields?.includes('netBookedValue') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_6">Net Booked Value</Label>
                <span>$ {item.netBookedValue || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('equipmentClass') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_7">Equipment Class</Label>
                <span>{item.eqClass || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('cost') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_8">Cost</Label>
                <span>$ {formatPrice(item?.cost, 2) ?? '$ 0.00'}</span>
              </div>
            </Col>}
            {fields?.includes('leaseId') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_9">Lease ID</Label>
                <span>{item?.leaseId || '-'}</span>
              </div>
            </Col>}
            {fields?.includes('leaseExpirationDate') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_10">Expected Lease Expiration Date - Include Extension or Renewal Options</Label>
                <span>{item?.leaseExpirationDate ? moment(item?.leaseExpirationDate).format('MM/DD/YYYY') : '-'}</span>
              </div>
            </Col>}
            {fields?.includes('isRepairRequest') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_11">Is this request for a repair of any kind?</Label>
                <span>{item.isRepairRequest === null ? '-' : item.isRepairRequest ? 'Yes' : 'No'}</span>
              </div>
            </Col>}
            {fields?.includes('isRepairValueOver1500') && <Col xl={3} md={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_12">Is the value of the repair over $1500</Label>
                <span>{item.isRepairValueOver1500 === null ? '-' : item.isRepairValueOver1500 ? 'Yes' : 'No'}</span>
              </div>
            </Col>}
            {fields?.includes('isEfficiencyIncreased') && <Col xl={3} lg={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_13">Will the operating capacity or
                  efficiency of the asset be substantially
                  increased</Label>
                <span>{item.isEfficiencyIncreased === null ? '-' : item.isEfficiencyIncreased ? 'Yes' : 'No'}</span>
              </div>
            </Col>}
            {fields?.includes('isLifeExtendedOneYear') && <Col xl={3} lg={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_14">Will the life of the asset be extended
                  ONE YEAR beyond the original useful
                  life</Label>
                <span>{item.isLifeExtendedOneYear === null ? '-' : item.isLifeExtendedOneYear ? 'Yes' : 'No'}</span>
              </div>
            </Col>}
            {fields?.includes('descAndJustification') && <Col xl={6} lg={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_15">Description and Justification Of Expenditure</Label>
                <span>{item.jeDescription}</span>
              </div>
            </Col>}
            {fields?.includes('address') && <Col xl={6} lg={4} className="pt-3">
              <div>
                <Label data-attribute="AfeDetail_Default_Label_16">{assetOrderHeaderDetail?.afeType  === CONSTANTS.FLEET_EQUIPMENT ? 'Branch Address Information' : 'Physical Address for Improvement'}</Label>
                <span>{item.addressLine1}, {item.addressLine2}, {item.city}, {item.state}, {item.zip}</span>
              </div>
            </Col>}
          </div>
        </Col>
      </div>
    </Col>
  </div>
}

export default AfeDetail;